// constants/videoEndpoints.ts
export const YOU_TUBE_VIDEO_URL = "https://www.youtube.com";
export const VIMEO_EMBED_URL = "https://vimeo.com";
export const YOUTUBE_THUMBNAIL_URL = "https://img.youtube.com/vi";
export const YOUTUBE_EMBED_URL = "https://www.youtube.com/embed";
export const VIMEO_THUMBNAIL_URL = "https://vumbnail.com";

export const getYouTubeVideoId = (url: string) => {
  const match = url.match(/(?:v=|youtu\.be\/)([A-Za-z0-9_-]{11})/);
  return match ? match[1] : null;
};

export const getVimeoVideoId = (url: string) => {
  const match = url.match(/vimeo\.com\/(\d+)/);
  return match ? match[1] : null;
};

export const getVideoThumbnailUrl = (url: string) => {
  if (url?.includes(YOU_TUBE_VIDEO_URL) || url?.includes(VIMEO_EMBED_URL)) {
    const videoId = getYouTubeVideoId(url);
    return videoId ? `${YOUTUBE_THUMBNAIL_URL}/${videoId}/mqdefault.jpg` : null;
  } else if (url?.includes(VIMEO_EMBED_URL)) {
    const videoId = getVimeoVideoId(url);
    return videoId ? `${VIMEO_THUMBNAIL_URL}/${videoId}.jpg` : null;
  }
  return null;
};

export const getVideoEmbedUrl = (url: string) => {
  if (url?.includes(YOU_TUBE_VIDEO_URL)) {
    const videoId = getYouTubeVideoId(url);
    return videoId ? `${YOUTUBE_EMBED_URL}/${videoId}` : null;
  } else if (url?.includes(VIMEO_EMBED_URL)) {
    const videoId = getVimeoVideoId(url);
    return videoId ? `${VIMEO_EMBED_URL}/${videoId}` : null;
  }
  return null;
};